import { render, staticRenderFns } from "./EventsListing.vue?vue&type=template&id=0b374fae&scoped=true&"
import script from "./EventsListing.vue?vue&type=script&lang=js&"
export * from "./EventsListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b374fae",
  null
  
)

export default component.exports